import React from 'react';
import { ShoppingBag } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  showIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  showIcon = true,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-heading font-bold text-lg transition-transform hover:scale-105 active:scale-95 shadow-soft cursor-pointer no-underline';
  const variantStyles = {
    primary: 'bg-brand-amber text-white hover:bg-amber-500',
    secondary: 'bg-brand-green text-white hover:bg-green-600'
  };
  const allStyles = `${baseStyles} ${variantStyles[variant]} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={allStyles} data-id="element-52">
        {showIcon && <ShoppingBag className="w-5 h-5" data-id="element-53" />}
        {children}
      </a>;
  }
  return <button className={allStyles} {...props} data-id="element-54">
      {showIcon && <ShoppingBag className="w-5 h-5" data-id="element-55" />}
      {children}
    </button>;
}